import classNames from 'classnames';
import React, { useContext } from 'react';
import { type IGraphColors, type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useEditor } from '@/hooks/use-editor';
import { useGlobalWidget } from '@/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { VectorPanelContext } from '../../context';
import { Tracker } from '../../utils';
import './style.less';
import { VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';

export const PieceColorPicker: React.FC = () => {
    const { layerId, recordId } = useContext(VectorPanelContext)!;

    const { $t } = useLocaleStore();

    const editor = useEditor();
    const colors = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return [];

        const layerData = layer.data as IVectorLayerProps;
        return layerData.colors;
    }) as IGraphColors[];

    const popoverWidgetRef = useGlobalWidget(editor, false);

    const handleColorPickerOpenChange = (open: boolean) => {
        popoverWidgetRef.current = open;

        if (open) {
            Tracker.openPieceColorPicker({
                recordId,
                stageType: editor.stage.getType(),
            });
        }
    };

    const setPieceColor = (index: number, color: string, options = { writeHistory: true }) => {
        editor.getInstance(VectorLayer).setPieceColor(layerId, index, color, options);

        if (options.writeHistory) {
            Tracker.setPieceColor({
                recordId,
                stageType: editor.stage.getType(),
            });
        }
    };

    if (colors.length === 0) return null;

    return (
        <div
            className={classNames('piece-color-picker', {
                'piece-color-picker--column': colors.length > 5,
            })}
        >
            <div className="piece-color-picker__title">{$t((v) => v.panel.vectorPanel.color)}</div>
            <div className="piece-color-picker__colors">
                {colors.map((item, index) => {
                    const { color } = item;

                    return (
                        <div key={index} className="piece-color-picker__color">
                            <ColorGroup
                                popupOverlayClassName="c-vector-panel__color-picker"
                                color={color}
                                setColor={(value) => setPieceColor(index, value, { writeHistory: false })}
                                setColorAfter={(value, _, { isBrandColor }) => {
                                    setPieceColor(index, value, { writeHistory: true });

                                    if (isBrandColor) {
                                        window._stat_track?.('hb_layers_func_use', {
                                            func_id: '9_107',
                                        });
                                    }
                                }}
                                customPopupTrigger={
                                    <div className="piece-color-picker__item" style={{ backgroundColor: color }} />
                                }
                                onOpenChange={handleColorPickerOpenChange}
                                onToggleBizTab={(bizTab) => {
                                    if (bizTab === 'team') {
                                        window._stat_track?.('hb_layers_func_click', {
                                            func_id: '9_107',
                                        });
                                    }
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
